import { Component, Input } from '@angular/core';

import { LanguageService } from '@fry/lib/organisations/language.service';


@Component({
    selector: 'eas-translation-info-list',
    templateUrl: './translation-info-list.component.html',
    styleUrls: ['./translation-info-list.component.css'],
    standalone: false
})
export class TranslationInfoListComponent {
  @Input() translationInfo: any;

  originalLanguageCode: string | undefined;

  constructor(
    private language: LanguageService,
  ) { }

  ngOnInit() {
    this.originalLanguageCode = this.language.getOriginalLanguageCode();
  }
}
